import { convertBlobToBase64 } from './helpers';

const SVG_NS = 'http://www.w3.org/2000/svg';
const XLINK_NS = 'http://www.w3.org/1999/xlink';

/**
 * Serialise the drawn graph as a standalone SVG document, cropped to the graph's bounds.
 * Local (blob:) images are embedded as data URIs so the file stands on its own.
 */
export const exportSvg = async (svgElement, { padding = 20 } = {}) => {
  const graph = svgElement?.querySelector('[data-layer="graph"]');
  if (!graph) return null;

  const bbox = graph.getBBox(); // in world units (excludes the layer's own transform)
  const clone = graph.cloneNode(true);
  clone.removeAttribute('transform');
  clone.querySelectorAll('[data-hit], [data-layer="connection"], [data-edge-handle]').forEach((el) => el.remove());
  // interaction-only attributes have no place in a figure
  [clone, ...clone.querySelectorAll('*')].forEach((el) => {
    el.removeAttribute('style');
    el.removeAttribute('dominant-baseline');
    el.removeAttribute('alignment-baseline');
    [...el.attributes]
      .filter((attr) => attr.name.startsWith('data-'))
      .forEach((attr) => el.removeAttribute(attr.name));
  });

  const images = [...clone.querySelectorAll('image')];
  await Promise.all(images.map(async (image) => {
    const href = image.getAttribute('href') || image.getAttributeNS(XLINK_NS, 'href');
    if (href && href.startsWith('blob:')) {
      image.setAttribute('href', await convertBlobToBase64(href));
    }
  }));

  const width = Math.ceil(bbox.width + padding * 2);
  const height = Math.ceil(bbox.height + padding * 2);
  const svg = document.createElementNS(SVG_NS, 'svg');
  svg.setAttribute('xmlns', SVG_NS);
  svg.setAttribute('xmlns:xlink', XLINK_NS);
  svg.setAttribute('viewBox', `${bbox.x - padding} ${bbox.y - padding} ${width} ${height}`);
  svg.setAttribute('width', String(width));
  svg.setAttribute('height', String(height));
  svg.appendChild(clone);

  return `<?xml version="1.0" encoding="UTF-8"?>\n${new XMLSerializer().serializeToString(svg)}`;
};

export const downloadText = (text, filename, type) => {
  const blob = new Blob([text], { type });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
};
